module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAARVBMVEXKACf/1RQmQnDxoxr80RbOECYAK38AGYv/7RT/2RHKACf/1RQmQnDxoxr80RYAK3/OESbNCyb/2REAGYv/7RQmQnDxoxogNzupAAAADnRSTlP49vXz8fHx8fHx6+no5toLh8gAAABlSURBVHja7dpHEYAwAADB0Hsv/qXiIOHF8NgzsAYu1LGacejKVO3UV9HCEuu49n1Odd7btsZKGHn2wigCg8FgMBgMBoPBYDAYDAaDwWAwGAwGg8FgMBgMBoPBYPzL+OK/+uIjewD2iybMXvjtvwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Romania.png
// module id = 607
// module chunks = 0